import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=06d69350&scoped=true&"
import script from "./previewImage.vue?vue&type=script&lang=js&"
export * from "./previewImage.vue?vue&type=script&lang=js&"
import style0 from "./previewImage.vue?vue&type=style&index=0&id=06d69350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d69350",
  null
  
)

export default component.exports